// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class CoolingCompanionModule {}
